import styled from 'styled-components'

export const TabContent = styled.div`
  padding: 1.5em;
`
